import { h } from 'preact';
import * as BaseComp from 'components/pages/projects/projects.js';
import Store from 'store/store';
import * as actions from 'store/actions';
// import s from 'components/pages/projects/projects.sss';

export default class Projects extends BaseComp.default {
	componentDidMount() {
		window.trackButton = (action, category, label) => {
			Store.emit(actions.POWSTER_GA_EVENT_TRACK, action, category, label);
		}
	}
}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
